import { render, staticRenderFns } from "./HistoryItemTypeAssemblyComment.vue?vue&type=template&id=fd0630fc&scoped=true&"
import script from "./HistoryItemTypeAssemblyComment.vue?vue&type=script&lang=js&"
export * from "./HistoryItemTypeAssemblyComment.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemTypeAssemblyComment.vue?vue&type=style&index=0&id=fd0630fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0630fc",
  null
  
)

export default component.exports